<script setup lang="ts">
import { onMounted, ref } from 'vue';

const isVisible = ref<boolean>(false);

onMounted(() => {
  isVisible.value = true;
});
</script>

<template>
  <transition name="up-and-down-slide">
    <slot v-if="isVisible" />
  </transition>
</template>

<style scoped lang="scss">
.up-and-down-slide-enter-active,
.up-and-down-slide-leave-active {
  transition: transform var(--transition-short);
}

.up-and-down-slide-enter-from,
.up-and-down-slide-leave-to {
  transform: translateY(100%);
}
</style>
